import type { OptimizelyUserInfo } from '@/main/lib/providers/OptimizelyProvider';
import type { Client } from '@optimizely/optimizely-sdk';
import { createContext, useContext } from 'react';

type OptimizelyContextType = {
  userFlags: OptimizelyUserInfo;
  optimizely: Client;
};

export const OptimizelyContext = createContext<OptimizelyContextType>({
  userFlags: {},
  optimizely: null,
});

export const useOptimizely = () => useContext(OptimizelyContext);
